/**
 * @fileoverview Dammen Stack Navigator Layout
 * @description Stack layout for Dammen game screens
 */

import { Stack } from "expo-router";
import { useThemeColors } from "@/providers/ThemeProvider";

export default function DammenLayout() {
  const colors = useThemeColors();

  return (
    <Stack
      screenOptions={{
        headerStyle: { backgroundColor: colors.background },
        headerTintColor: colors.text,
        headerTitleStyle: { fontWeight: "600" },
        contentStyle: { backgroundColor: colors.background },
      }}
    >
      <Stack.Screen
        name="index"
        options={{
          title: "Dammen",
          headerShown: true,
        }}
      />
      <Stack.Screen
        name="[sessionId]"
        options={{
          title: "Dammen",
          headerShown: true,
          headerBackTitle: "Terug",
        }}
      />
    </Stack>
  );
}

